import React, { useMemo, useState } from "react";
import axios from "axios";
import styled, { css } from "styled-components";
import { Confirmation, FormField, FormWrapper } from "./Form";
import Section from "./Section";
import Container from "./Container";
import { useStaticQuery, graphql } from "gatsby";
import { getGAClientId } from '../utils/getGAClientId';
import randomstring from "randomstring"

const ButtonStyles = styled.button`
  ${({ ...props }) => css`
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.15), 0 2px 2px rgba(0, 0, 0, 0.15),
      0 4px 4px rgba(0, 0, 0, 0.15), 0 8px 8px rgba(0, 0, 0, 0.15);
    min-width: 200px;
    @media (min-width: ${props.theme.breakpoints.md}) {
    }
  `}
`;

const FormFooterStyles = styled.div`
  ${({ ...props }) => css`
    h3 {
      margin-top: 24px;
    }
    a {
      color: ${props.theme.colors.primary};
    }
    @media (min-width: ${props.theme.breakpoints.md}) {
      margin-top: ${(props.$inline ? "24px" : "0px")};
      display: ${(props.$inline ? "flex" : "block")};
      justify-content: space-between;
      align-items: center;

      h3 {
        margin-top: ${(props.$inline ? "0" : "24px")};
      }
    }
  `}
`;

export const FeedbackForm = () => {
  const [serverState, setServerState] = useState({
    submitting: false,
    status: null,
  });

  const siteData = useStaticQuery(graphql`
    query FeedbackFormQuery {
      site {
        siteMetadata {
          feedbackFormEndpoint
        }
      }
    }
  `);

  const handleServerResponse = (ok, msg, form) => {
    setServerState({
      submitting: false,
      status: { ok, msg },
    });
    if (ok) {
      form.reset();
    }
  };
  const handleOnSubmit = (e) => {
    e.preventDefault();
    const form = e.target;
    setServerState({ submitting: true });
    axios({
      method: "post",
      url: siteData.site.siteMetadata.feedbackFormEndpoint,
      data: new FormData(form),
    })
      .then((r) => {
        handleServerResponse(true, "Thank you for your feedback", form);
      })
      .catch((r) => {
        handleServerResponse(false, r.response.data.error, form);
      });
  };

  const rand = useMemo(() => randomstring.generate(5), []);

  return (
    <Section grey>
      <Container slim>
        <FormWrapper>
          <h2>Before you go, we’d love to hear your quick feedback…</h2>
          <p>Is there anything that almost stopped you enquiring?</p>
          <form onSubmit={handleOnSubmit}>
            <input
              type="hidden"
              name="googleClientId"
              id={`${rand}_googleClientId`}
              value={getGAClientId()}
              hidden
            />
            <FormField>
              <textarea
                type="text"
                name="feedback"
                id={`${rand}_feedback`}
                aria-describedby="feedback"
                placeholder="Your feedback"
                required
              />
              <label htmlFor={`${rand}_feedback`}>Your feedback</label>
            </FormField>
            <FormFooterStyles>
              <div>
                <ButtonStyles
                  type="submit"
                  disabled={serverState.submitting}
                >
                  Send feedback
                </ButtonStyles>
                <p className="no-js">Please enable Javascript to continue</p>
                {serverState.status && (
                  <Confirmation>
                    <p className={!serverState.status.ok ? "errorMsg" : ""}>
                      {serverState.status.msg}
                    </p>
                  </Confirmation>
                )}
              </div>
            </FormFooterStyles>
          </form>
        </FormWrapper>
      </Container>
    </Section>
  );
};
